import React from "react";
import { ButtonIcon } from "@loanbossinc/component-library";
import styled from "styled-components";

const ButtonNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 1em;
  align-items: center;
`;

const Text = styled.div`
  font-family: Work Sans;
  font-size: 16px;
  font-weight: 500;
`;

const DropdownFilterHeader = ({ name = "sponsors", setVisibility = () => { } }) => (
  <div className="fp-header-wrapper">
    <ButtonNameContainer>
      <ButtonIcon
        iconName="arrow_back"
        onClick={() => setVisibility(false)}
        style={{ color: "black" }}
      />
      <Text>
        Filter by {name}
      </Text>
    </ButtonNameContainer>
  </div>
);

export default DropdownFilterHeader;
